import { defineStore } from 'pinia'
import beApiClient from "@/src/be-api-client";
import {APIRoute, EP, APIBaseRoute} from "@/src/endpoints";
import { handleErrors, makeRequest } from "@/src/utils";

export const useNotificationServiceStore = defineStore('notification-service', {
  state: ()=> {
    return {
      // lookup data
    }
  },
  actions: {
    // Generic load data method
    loadEntity(url, key, params = {}) {
      return new Promise((resolve, reject) => {
        beApiClient.get(url, params).then(response => {
          this[key] = response.data;
          resolve();
        }).catch(error => {
          const message = handleErrors(error);
          reject(message);
        });
      });
    },
    // Load all Services
    loadServices(params) {
      return makeRequest(beApiClient.get, APIRoute(EP.admin.integrations.webhook_to_notifications.index), { params: params });
    },
    // Load a Services
    loadService(id) {
      return makeRequest(beApiClient.get, APIRoute(EP.admin.integrations.webhook_to_notifications.show, { id: id }));
    },
    // Update Service
    updateService(payload) {
      return new Promise((resolve, reject) => {
        beApiClient.patch(APIRoute(EP.admin.integrations.webhook_to_notifications.update, { id: payload.id }), payload).then(response => {
          resolve(response.data);
        }).catch(error => {
          const message = handleErrors(error);
          reject(message);
        })
      });
    },
    // Create Service
    createService(payload) {
      return new Promise((resolve, reject) => {
        beApiClient.post(APIRoute(EP.admin.integrations.webhook_to_notifications.create), payload).then(response => {
          resolve(response.data);
        }).catch(error => {
          const message = handleErrors(error);
          reject(message);
        })
      });
    },
    
    
  }
});